import { UserManager, WebStorageStateStore } from "oidc-client-ts";

const oidcConfig: any = {
  authority: `${process.env.REACT_APP_KEYCLOAK_URL}/realms/${process.env.REACT_APP_KEYCLOAK_REALM}`,
  client_id: process.env.REACT_APP_KEYCLOAK_CLIENT_ID ?? "",
  redirect_uri:
    process.env.NODE_ENV === "production"
      ? process.env.REACT_APP_REDIRECT_URL_PRODUCTION
      : process.env.REACT_APP_REDIRECT_URL_DEVELOPMENT,
  response_type: "code",
  scope: "openid profile email",
  post_logout_redirect_uri:
    process.env.NODE_ENV === "production"
      ? process.env.REACT_APP_REDIRECT_URL_PRODUCTION
      : process.env.REACT_APP_REDIRECT_URL_DEVELOPMENT,
  automaticSilentRenew: false,
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  client_secret: process.env.REACT_APP_KEYCLOAK_CLIENT_SECRET,
};

export default oidcConfig;

export const userManager = new UserManager(oidcConfig);

userManager.events.addSilentRenewError((error) => {
  console.error("Silent renew error:", error);
});

userManager.events.addAccessTokenExpiring(() => {
  console.log("Access token is expiring");
});
